/**
 * WordPress dependencies.
 */
import { __,_x } from '@wordpress/i18n';

import {InspectorControls} from '@wordpress/block-editor';

import {
    Fragment,
    useState,
	
} from '@wordpress/element';

import {
	VayuBlocksHeaderTab,usePanelSettings
} from '@vayu-blocks';

import BlurbSettingPanel from './settings/index.js';
import { VayuBlocksAdvancePanel } from '@vayu-blocks/advance-panel';

const panelKeys = [
	'vb-blurb-set',
];

const initialPanels = {
	setting: 'vb-blurb-set',
    advanced: '',
};

const panelOptions = [
	{ label: __( 'Setting', 'vayu-blocks' ), value: 'setting', icon: 'colorwand'},
	{ label: __( 'Advanced', 'vayu-blocks' ), value: 'advanced', icon: 'colorpalette'}
];

const InsSettings = (props) => {

	const { attributes, setAttributes, clientId } = props;

	const {tab, setTab, openPanels, onTogglePanel  } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'setting' });
	const tabComponents = {
				setting: <BlurbSettingPanel attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
				advanced: <VayuBlocksAdvancePanel attributes={attributes} setAttributes={setAttributes} clientId={clientId} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		};

    return (
        <Fragment>
        <InspectorControls>
            <VayuBlocksHeaderTab 
					value={ tab }
					options={panelOptions}
					onChange={ setTab }
			/>	   
			{tabComponents[tab]}
                </InspectorControls>
                </Fragment>
               
        )

}

export default InsSettings;